import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from "react-apexcharts";

class NewCalls extends Component {
  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    chartOptions: {
      title: {
        text: "Atendimento",
        align: "center",
        margin: 40,
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          color: "#263238",
        },
      },
      labels: [
        "Chamadas que deram em pedido",
        "Chamadas que não deram em pedido",
      ],
      legend: {
        show: true,
        position: "bottom",
        fontSize: "13px",
      },
      colors: ["#A9A9A9", "#20B2AA"],
    },
  };

  render() {
    return (
      <div class="requests-chart">
        {this.props.newCalls && (
          <Chart
            title={this.state.title}
            options={this.state.chartOptions}
            series={[
              this.props.newCalls[0].requests,
              this.props.newCalls[0].not_requests,
            ]}
            type="pie"
            width="480"
          />
        )}
      </div>
    );
  }
}
export default NewCalls;
